export class AspectKeyActive {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspectKey() {
        return this.parent;
    }
    get aspect() {
        return this.aspectKey.aspect;
    }
    get activeTraits() {
        return this.aspectKey.keyReduced.reducedTraits;
    }
}
